import { sendLoginToken, receiveLastScope } from "../api/api";
import { scopes_B2B, scopes_B2C, scopes_B2C_Telco, scopes_O2, scopeValuesQuestionInput, scopeValuesQuestionInput_O2, scopeValuesQuestionInput_eSimFlag, scopeValuesQuestionInput_Telco, seccions, scopes_B2B_Migedi, scopes_eSimFlag } from "../infraestructure/models";
import { loginTokenResponse, Canalizacion, PriorityGroups } from "../api";

export async function verifyToken(token: string) {
    const sendedToken = await sendLoginToken(token);
    console.log("========sendedToken========");
    console.log(sendedToken);
    let result = {user: '', userName: '', token: {} as loginTokenResponse, origin: '', scope: '', seccion: '', login: false, errorTokenMessage: '', errorTokenLogin: false, salesMediaName: '', pindi: '', userDepartment: '', canalizacion: undefined as Canalizacion | undefined, priorityGroups: undefined as PriorityGroups | undefined};
    if (!sendedToken.error && sendedToken.status === 200) {
        let user_name = sendedToken.user;
        if(user_name.length>12){
                user_name = "Usuario Telco";
        } 
        result.token=sendedToken
        result.user = sendedToken.user
        result.userName = user_name
        result.origin = sendedToken.origin!
        result.salesMediaName = result.token.salesMediaName || '';
        result.pindi = result.token.pindi || '';
        result.userDepartment = result.token.userDepartment || '';
        result.canalizacion = sendedToken.canalizacion || undefined;
        result.priorityGroups = sendedToken.priorityGroups || undefined;
        console.log(user_name);
        // Verificación específica para el usuario 'Telco'
        // sendedToken.scope es el userDepartment realmente, lo que es el scope como tal es result.scope
        if (
            scopeValuesQuestionInput_Telco.includes(sendedToken.scope) ||
            sendedToken.scope?.startsWith("CRC_TELCO")
        ) {   
            const canalizacionNames = result.canalizacion?.category15_names || [];
            const groupNames = result.priorityGroups?.priorityGroups_groupNames || [];
            const valueNames = result.priorityGroups?.priorityGroups_valueNames || [];
            console.log("CANALIZACION NAMES: " + canalizacionNames);
            console.log("GROUP NAMES: " + groupNames);
            console.log("VALUE NAMES: " + valueNames);
            const valueNamesClean = valueNames.map((name: string) =>
                name.startsWith("#") ? name.slice(1) : name
            );
            console.log("VALUE NAMES CLEAN: " + valueNamesClean);
            const categoryNames = canalizacionNames
                .filter(
                    name =>
                        !groupNames.includes(name) &&
                        !valueNamesClean.includes(name)
                )
                .join(",");
            console.log("CATEGORY NAMES: " + categoryNames);
            if (sendedToken.userDepartment === "CRC_TELCO_O2_ESIMFLAG") {
                result.scope = scopes_eSimFlag[0];
                result.seccion = seccions[3]
            }
            else {
                result.scope = categoryNames || scopes_B2C_Telco[1];
                result.seccion = seccions[1]
            }
            console.log("El usuario es Telco.");
        }
        else{
            if (scopeValuesQuestionInput.includes(sendedToken.scope)) {
                const canalizacionNames = result.canalizacion?.category15_names || [];
                const groupNames = result.priorityGroups?.priorityGroups_groupNames || [];
                const valueNames = result.priorityGroups?.priorityGroups_valueNames || [];

                const valueNamesClean = valueNames.map((name: string) =>
                    name.startsWith("#") ? name.slice(1) : name
                );

                const categoryNames = canalizacionNames
                    .filter(
                        name =>
                            !groupNames.includes(name) &&
                            !valueNamesClean.includes(name)
                    )
                    .join(",");

                result.scope = categoryNames || scopes_B2C[1];
                result.seccion = seccions[1]
            } else if (scopeValuesQuestionInput_O2.includes(sendedToken.scope)) {
                await receiveLastScope(seccions[2],"token")
                    .then((response) => {
                        result.scope = scopes_O2[0]
                        if (response.length > 1) {
                            console.log('LENGTH SCOPE: ' + response.length)
                            result.scope = response
                        }
                    })
                    .catch((e) => console.log(console.log(e)));
                result.seccion = seccions[2]
            } else if (scopeValuesQuestionInput_eSimFlag.includes(sendedToken.scope)) {
                result.scope = scopes_eSimFlag[0];
                result.seccion = seccions[3]
            } else {
                if (result.userDepartment === "MIGEDI") {
                    result.scope = scopes_B2B_Migedi[3];
                } else {
                await receiveLastScope(seccions[0],"token")
                    .then((response) => {
                        result.scope = scopes_B2B[0]
                        if (response.length > 1) {
                            console.log('LENGTH SCOPE: ' + response.length)
                            result.scope = response
                        }
                    })
                    .catch((e) => console.log(console.log(e)));
                }
                result.seccion = seccions[0]
            }
            console.log("El usuario NO ES Telco");
        }
        result.login = true
    } else {
        console.log("TOKEN NOT VERIFIED");
        result.errorTokenMessage = sendedToken.message!
        result.errorTokenLogin = true
    }
    return result
};

